function SchedulingWidget(options) {
    var options = options ? options : {};
    var defaults = {

    };

    this.opts = Object.assign(defaults, options);
    this.element = document.querySelector(this.opts.element);
    this.timePickerTemplate = document.querySelector(this.opts.timePickerTemplate).innerHTML;
    this.timePickerItemTemplate = document.querySelector(this.opts.timePickerItemTemplate).innerHTML;
    this.timeStart = 360;
    this.timeStep = 30;

    this.init();
    this.initTimePicker();
}

SchedulingWidget.prototype.init = function ()
{
    var that = this;

    // Button for open the time picker
    this.on(this.element, 'click', '.add-time-button', function(e){
        e.preventDefault();
        var parent = this.parentElement.parentElement;
        var timePicker = parent.querySelector('.time-picker');
        if (timePicker.classList.contains('show')) {
            parent.querySelector('.time-picker').classList.remove('show');
        } else {
            parent.querySelector('.time-picker').classList.add('show');
        }
    });

    // Cancel button to close time picker
    this.on(this.element, 'click', '.time-picker .close', function(e){
        e.preventDefault();
        that.closeTimePicker(this.parentElement);
    });

    // Button for adding time
    this.on(this.element, 'click', '.time-picker .add-time', function(e){
        e.preventDefault();
        var timePicker = this.parentElement;
        var weekday = this.parentElement.parentElement.parentElement.dataset.weekday;
        var inputBegin = timePicker.querySelector('.input-begin').value;
        var inputEnd = timePicker.querySelector('.input-end').value;
        var validateInput = that.validateInput(inputBegin, inputEnd, weekday);

        if (validateInput === true) {
            return that.addTime.call(that, inputBegin, inputEnd, weekday, this);
        }
        alert(validateInput);
    });

    // Show button for deleting when hovering the item
    this.on(this.element, 'mouseover', '.scheduling-item', function(e){
        e.preventDefault();
        var deleteItem = this.querySelector('.delete-item');
        deleteItem.classList.add('show')
    });

    // Hide button for deleting when leaving the item
    this.on(this.element, 'mouseout', '.scheduling-item', function(e){
        e.preventDefault();
        var deleteItem = this.querySelector('.delete-item');
        deleteItem.classList.remove('show')
    });

    // Button click action for deleting a time from scheduling
    this.on(this.element, 'click', '.scheduling-item .delete-item', function(e){
        e.preventDefault();
        var scheduling = this.parentElement.parentElement;
        var scheduleItem = this.parentElement;
        var scheduleControl = scheduleItem.dataset.control;
        var scheduledHours = that.element.querySelector('.scheduled-hours');
        var scheduleItemInput = that.element.querySelector('.scheduled-hours .' + scheduleControl);
        scheduledHours.removeChild(scheduleItemInput);
        scheduling.removeChild(scheduleItem)
    });
}

SchedulingWidget.prototype.initTimePicker = function ()
{
    var timePickerContainer = this.element.querySelectorAll('.time-picker');
    var timePickerTemplate = this.timePickerTemplate;
    var hours = this.getHours();

    timePickerContainer.forEach(function(e, i) {
        Mustache.parse(timePickerTemplate);
        var renderedTimePicker = Mustache.render(
            timePickerTemplate,
            {
                hours: hours,
            }
        );
        e.innerHTML = renderedTimePicker;
    });
}

SchedulingWidget.prototype.closeTimePicker = function (el)
{
    el.classList.remove('show');
}

SchedulingWidget.prototype.getProportions = function (begin, end)
{
    var schedulingWidth = document.querySelector('.scheduling-widget .scheduling').offsetWidth;
    var rate = ( schedulingWidth / 48 ).toFixed(4);
    var timeProportion = ( begin - this.timeStart ) / this.timeStep;
    var timePickerItemLeft = Math.ceil( timeProportion * rate );
    var timeProportionRateMultiplier = (end - begin) / this.timeStep;
    var timePickerItemSize = Math.ceil( ( (end == 1770) ? timeProportionRateMultiplier + 1 : timeProportionRateMultiplier )  * rate );

    return {
        left: timePickerItemLeft,
        width: timePickerItemSize,
        multiplier: timeProportionRateMultiplier,
    };
}

SchedulingWidget.prototype.getHours = function ()
{
    var hours = [];
    var timeStart = this.timeStart;
    for(i = 1; i <= 48; i++) {
        var date = new Date('1970-01-01T00:00:00');
        date.setMinutes(timeStart);
        hours.push({
            time: timeStart,
            label: this.getFormattedHour(timeStart),
        });
        timeStart += this.timeStep;
    }
    return hours;
}

SchedulingWidget.prototype.addTime = function (begin, end, weekday, el)
{
    var proportions = this.getProportions(begin, end);
    var scheduling = el.parentNode.parentNode.querySelector('.scheduling');

    // Mustache template
    var timePickerItemTemplate = this.timePickerItemTemplate;
    Mustache.parse(timePickerItemTemplate);
    var timePickerItemRendered = Mustache.render(
        timePickerItemTemplate,
        {
            begin: this.getFormattedHour(begin),
            end: this.getFormattedHour(end),
            scheduling_control: 'scheduling-' + begin + end + weekday,
            show_label: (proportions.multiplier > 7),
        }
    );
    var schedulingItemHtml = this.stringToDom(timePickerItemRendered);
    schedulingItemHtml.style.left = proportions.left + 'px';
    schedulingItemHtml.style.width = proportions.width + 'px';

    // Add element to the scheduling row
    scheduling.appendChild(schedulingItemHtml);

    // Add Input
    this.addTimeFields(begin, end, weekday);

    // Close Time Picker
    this.closeTimePicker(el.parentNode);
}

SchedulingWidget.prototype.addTimeFields = function (begin, end, weekday)
{
    var input = document.createElement('input');
    var scheduledHours = this.element.querySelector('.scheduled-hours');

    input.setAttribute('type', 'hidden');
    input.setAttribute('class', 'scheduling-' + begin + end + weekday + ' weekday-' + weekday);
    input.setAttribute('name', 'scheduledHours[' + weekday + '][]');
    input.setAttribute('value', begin + '|' + end);

    scheduledHours.appendChild(input);
}

SchedulingWidget.prototype.checkConflictingHours = function (begin, end, weekday)
{
    var times = this.element.querySelectorAll('.scheduled-hours input.weekday-'+weekday);
    var conflict = false;
    times.forEach(function(e, i){
        var hours = e.value.split('|');
        if (
            (begin == hours[0] || end == hours[1]) ||
            ((begin > hours[0] && begin < hours[1]) || (end > hours[0] && end < hours[1]))
            ) {
            conflict = true;
        }
    });

    return conflict;
}

SchedulingWidget.prototype.validateInput = function (begin, end, weekday)
{
    var begin = parseInt(begin);
    var end = parseInt(end);

    if (begin === end) {
        return SCHEDULING_WIDGET_ERROR_SAME_TIME;
    } else if (end < begin) {
        return SCHEDULING_WIDGET_ERROR_END_BIGGER_THAN;
    } else if(this.checkConflictingHours(begin, end, weekday)) {
        return SCHEDULING_WIDGET_ERROR_TIME_CONFLICT;
    } else {
        return true;
    }
}

SchedulingWidget.prototype.getFormattedHour = function (minutes)
{
    var date = new Date('1970-01-01T00:00:00');
    date.setMinutes(minutes);
    var hours = (date.getHours().toString().length < 2) ? '0' + date.getHours() : date.getHours();
    var minutes = (date.getMinutes().toString().length < 2) ? '0' + date.getMinutes() : date.getMinutes();
    return hours + ':' + minutes;
}

SchedulingWidget.prototype.stringToDom = function (string)
{
    var container = document.createElement('div');
    container.innerHTML = string;
    return container.children[0];
}

/**
 * Append event to element
 *
 * @param {dom} el Element
 * @param {string} evt Event name
 * @param {string} sel Element selector identifier
 * @param {function} handler Callback function
 */
SchedulingWidget.prototype.on = function(el, evt, sel, handler) {
    var that = this;
    el.addEventListener(evt, function(event) {
        var t = event.target;
        while (t && t !== this) {
            if (t.matches(sel)) {
                handler.call(t, event);
            }
            t = t.parentNode;
        }
    });
};
